import { NormalBrowseFileInputFiled, NormalTextInputField } from "@/components";
import React, { useMemo } from "react";

const HomeAgentRegistrationSectionFormField = ({
  activeLang,
  isFetching,
  allFilesResponse,
  searchValue,
  selectedFileType,
  onChangeImage,
  handleTextInputChange,
  stateDetails,
  adminRole,
  permissionsList,
}) => {
  const isHideInOtherLanguages = useMemo(() => {
    return activeLang === "en";
  }, [activeLang]);

  const getImageId = (id) => {
    if (id) {
      onChangeImage("home-section-11-agent-registration-image", id);
    } else {
      onChangeImage("home-section-11-agent-registration-image", "");
    }
  };

  return (
    <>
      {/* Title */}
      <NormalTextInputField
        isFetching={isFetching}
        labelText="Title"
        fieldId="home-section-11-agent-registration-title"
        fieldName="home-section-11-agent-registration-title"
        placeholderText="Title"
        inputValue={
          stateDetails?.["home-section-11-agent-registration-title"] || ""
        }
        onChangeTextInputField={handleTextInputChange}
        extraContainerClasses="mb-5"
        translateField={true}
      />

      {/* Description */}
      <NormalTextInputField
        isFetching={isFetching}
        isTextArea={true}
        labelText="Description"
        fieldId="home-section-11-agent-registration-description"
        fieldName="home-section-11-agent-registration-description"
        placeholderText="Description"
        inputValue={
          stateDetails?.["home-section-11-agent-registration-description"] || ""
        }
        onChangeTextInputField={handleTextInputChange}
        extraContainerClasses="mb-5"
        translateField={true}
      />

      {/* About Company Image */}
      {isHideInOtherLanguages && (
        <NormalBrowseFileInputFiled
          isFetching={isFetching}
          labelText="Image"
          fieldId="home-section-11-agent-registration-image"
          allFilesResponse={allFilesResponse}
          searchValue={searchValue}
          selectedFileType={selectedFileType}
          onChangeImageFunction={getImageId}
          selectedFileId={
            stateDetails?.["home-section-11-agent-registration-image"] || ""
          }
          adminRole={adminRole}
          permissionsList={permissionsList}
          extraContainerClasses="mb-5"
        />
      )}

      {/* Button Label */}
      <NormalTextInputField
        isFetching={isFetching}
        labelText="Button Label"
        fieldId="home-section-11-agent-registration-button-label"
        fieldName="home-section-11-agent-registration-button-label"
        placeholderText="Button Label"
        inputValue={
          stateDetails?.["home-section-11-agent-registration-button-label"] ||
          ""
        }
        onChangeTextInputField={handleTextInputChange}
        extraContainerClasses="mb-5"
        translateField={true}
      />
    </>
  );
};

export default HomeAgentRegistrationSectionFormField;
